import { render, staticRenderFns } from "./DubaiInvestmentFeatures.vue?vue&type=template&id=681a7aed"
import script from "./DubaiInvestmentFeatures.vue?vue&type=script&lang=js"
export * from "./DubaiInvestmentFeatures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports